import { createRouter, createWebHistory } from 'vue-router'
import { routes } from '@/plugins/router/routes'
import {
	ensureRouteExists,
	loginGuard,
	policyGuard,
	itemNaNGuard,
	removeTrailingSlashGuard,
	modalGuard,
	aliasGuard,
} from 'plugins/router/guards'
import { addRouteToHistory } from 'plugins/router/history.ts'

export { routes, routesFlat } from '@/plugins/router/routes'

const router = createRouter({
	routes: routes,
	history: createWebHistory(import.meta.env.BASE_URL),
})

router.beforeEach(aliasGuard)
router.beforeEach(modalGuard)
router.beforeEach(ensureRouteExists)
router.beforeEach(loginGuard)
router.afterEach(addRouteToHistory)
router.beforeEach(policyGuard)
router.beforeEach(itemNaNGuard)
router.beforeEach(removeTrailingSlashGuard)

export { router }
